import { enc, mode, AES, pad } from "crypto-js";
let aseConfig = window.aseConfig + ''

function aesDecryptParams(encryptedWord) {
  const keyUTF8 = enc.Utf8.parse('15441489487797985281544144278404');
  const offsetUTF8 = enc.Utf8.parse('dsfdsgffyyy');
  const bytes = AES.decrypt(encryptedWord, keyUTF8, {
    iv: offsetUTF8,
    mode: mode.CBC,
    padding: pad.Pkcs7,
  });

  return bytes.toString(enc.Utf8);
}
let sgiSrvUrl = JSON.parse(aesDecryptParams(aseConfig))
// 解密挂载
window.sgiSrvUrl = sgiSrvUrl


// WEBPACK FOOTER //
// ./apps/resolveConfig.js